"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCache = exports.handleResponseTarget = exports.handleResponseDataToMap = exports.handleResponseDataToList = exports.handleGetTargetFiled = exports.handleExecutiveInvoking = exports.getCache = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../utils");
var _excluded = ["key"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/**
 * 获取目标字段值
 * */
var handleGetTargetFiled = function handleGetTargetFiled(data) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var list = [];
  for (var key in data) {
    var item = data[key];
    if (key === field) {
      list = item || [];
      return list;
    } else if ((0, _utils.isObject)(item) || (0, _utils.isArray)(item)) {
      return handleGetTargetFiled(item, field);
    }
  }
};
/**
 * 获取指定字段值list
 * */

exports.handleGetTargetFiled = handleGetTargetFiled;
var handleResponseDataToList = function handleResponseDataToList() {
  var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data';
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var protoNum = Object.keys(data).length;
    if (!data || (0, _utils.isObject)(data) && !protoNum) {
      return [];
    }
    return data[field];
  };
};
/*
* 获取指定字段
* */

exports.handleResponseDataToList = handleResponseDataToList;
var handleResponseTarget = function handleResponseTarget() {
  var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data';
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return data[field];
  };
};
/**
 * list 数据转换
 * */

exports.handleResponseTarget = handleResponseTarget;
var handleResponseDataToMap = function handleResponseDataToMap(_ref) {
  var _ref$labelKey = _ref.labelKey,
    labelKey = _ref$labelKey === void 0 ? '' : _ref$labelKey,
    _ref$valueKey = _ref.valueKey,
    valueKey = _ref$valueKey === void 0 ? '' : _ref$valueKey;
  return function () {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return list.map(function (x) {
      var label = x;
      var value = x;
      if ((0, _utils.isObject)(x)) {
        label = x[labelKey];
        value = x[valueKey];
      }
      return _objectSpread(_objectSpread({}, x), {}, {
        label: label,
        value: value
      });
    });
  };
}; // 获取缓存中的数据

exports.handleResponseDataToMap = handleResponseDataToMap;
var getCache = function getCache() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';
  return function (_ref2) {
    var key = _ref2.key;
    var value = window[type].getItem(key);
    var cache = null;
    try {
      cache = JSON.parse(value); // 保存数据为空

      var isEmpty = !cache.data; // 没存储或已过期 或 保存数据为空

      if (!cache || cache.expiration < +new Date() - 30 * 60 * 1000 || isEmpty) {
        cache = null;
      }
    } catch (e) {
      cache = null;
    }
    return cache;
  };
}; // 设置缓存数据

exports.getCache = getCache;
var setCache = function setCache() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';
  return function (_ref3) {
    var key = _ref3.key,
      data = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
    var value = JSON.stringify(_objectSpread(_objectSpread({}, data), {}, {
      expiration: +new Date()
    }));
    window[type].setItem(key, value);
    return data;
  };
}; // 执行调用

exports.setCache = setCache;
var handleExecutiveInvoking = function handleExecutiveInvoking(value) {
  return typeof value === 'function' ? value() : value;
};
exports.handleExecutiveInvoking = handleExecutiveInvoking;